import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.js'
import { installStyles } from './styles.js'

window.__OFFERFLOW_API_BASE__ = '/api'
installStyles()

const root = document.getElementById('root')
if (root === null) throw new Error('OfferFlow root element is missing')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
